(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sale-offers-promo-codes"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(value) {
    return (value < 10 ? '0' : '') + value;
  }

  function parseCountdownEnd(str) {
    if (!str) return NaN;
    str = String(str).trim();
    if (!str) return NaN;

    var parsed = Date.parse(str);
    if (!isNaN(parsed)) return parsed;

    parsed = Date.parse(str.replace(' ', 'T'));
    if (!isNaN(parsed)) return parsed;

    var match = str.match(/^(\d{4})-(\d{2})-(\d{2})[T\s](\d{2}):(\d{2})(?::(\d{2}))?/);
    if (!match) return NaN;

    return new Date(
      parseInt(match[1], 10),
      parseInt(match[2], 10) - 1,
      parseInt(match[3], 10),
      parseInt(match[4], 10),
      parseInt(match[5], 10),
      parseInt(match[6] || '0', 10)
    ).getTime();
  }

  function fallbackCopy(text, callback) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
      if (callback) callback();
    } catch (e) {}
    document.body.removeChild(textarea);
  }

  function initCopyButtons(root) {
    root.querySelectorAll('[data-copy-code]').forEach(function (btn) {
      if (btn.getAttribute('data-copy-bound') === 'true') return;
      btn.setAttribute('data-copy-bound', 'true');

      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-copy-code');
        if (!code) return;

        function markCopied() {
          btn.classList.add('is-copied');
          var copiedLabel = btn.getAttribute('data-copied-label') || 'Copied';
          btn.setAttribute('aria-label', copiedLabel + ': ' + code);
          window.setTimeout(function () {
            btn.classList.remove('is-copied');
            var copyLabel = btn.getAttribute('data-copy-label') || 'Copy code';
            btn.setAttribute('aria-label', copyLabel + ': ' + code);
          }, 2000);
        }

        if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
          navigator.clipboard.writeText(code).then(markCopied).catch(function () {
            fallbackCopy(code, markCopied);
          });
        } else {
          fallbackCopy(code, markCopied);
        }
      });
    });
  }

  function initCountdown(root) {
    if (root.getAttribute('data-countdown-bound') === 'true') return;

    var endDateStr = root.getAttribute('data-countdown-end');
    if (!endDateStr) return;

    var endTime = parseCountdownEnd(endDateStr);
    if (isNaN(endTime)) return;

    var daysEl = root.querySelector('[data-countdown-days]');
    var hoursEl = root.querySelector('[data-countdown-hours]');
    var minutesEl = root.querySelector('[data-countdown-minutes]');
    var secondsEl = root.querySelector('[data-countdown-seconds]');
    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

    root.setAttribute('data-countdown-bound', 'true');

    if (root._soPromoCountdownInterval) {
      window.clearInterval(root._soPromoCountdownInterval);
    }

    function updateCountdown() {
      var diff = endTime - Date.now();
      if (diff <= 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        window.clearInterval(root._soPromoCountdownInterval);
        root._soPromoCountdownInterval = null;
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);
    }

    updateCountdown();
    root._soPromoCountdownInterval = window.setInterval(updateCountdown, 1000);
  }

  function initPromoSection(root) {
    if (!root) return;
    initCopyButtons(root);
    initCountdown(root);
  }

  function findPromoRoot(container) {
    if (!container) return null;
    if (container.matches && container.matches('[data-so-promo]')) return container;
    if (container.querySelector) return container.querySelector('[data-so-promo]');
    return null;
  }

  function boot(container) {
    var scope = container || document;
    scope.querySelectorAll('[data-so-promo]').forEach(initPromoSection);
  }

  boot();

  document.addEventListener('shopify:section:load', function (event) {
    initPromoSection(findPromoRoot(event.target));
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = findPromoRoot(event.target);
    if (!root || !root._soPromoCountdownInterval) return;
    window.clearInterval(root._soPromoCountdownInterval);
    root._soPromoCountdownInterval = null;
    root.removeAttribute('data-countdown-bound');
  });
})();

  } catch(e) { console.error(e); }
})();
})();
